import { CustomCellActionsComponent } from '@app/components/shared/grids/custom-cell-actions/custom-cell-actions.component';
import { TabNames } from '@enums/TabNames';
import { ColDef, ICellRendererParams, ValueFormatterParams } from 'ag-grid-enterprise';

export const CONTACTS_GRID_COLUMNS: ColDef[] = [
    {
        colId: 'id',
        field: 'id',
        headerName: 'ID',
        width: 100,
        lockPinned: true,
        lockPosition: 'left',
        suppressSizeToFit: true,
        cellRenderer: (params: ICellRendererParams) => {
            if (params.value) {
                const link = `/contacts-single/${params.value}/${TabNames[TabNames.Overview]}`;
                return `<a class="anchor" href="${link}">${params.value}</a>`;
            }
            return '';
        }
    },
    {
        colId: 'fullName',
        field: 'fullName',
        headerName: 'Name',
        cellDataType: 'text'
    },
    {
        colId: 'phone',
        field: 'phone',
        headerName: 'Phone',
        cellDataType: 'text',
        sortable: false,
        valueFormatter: (params: ValueFormatterParams) => {
            if (Array.isArray(params.value)) {
                return params.value.join(', ');
            }
            return params.value || '';
        }
    },
    {
        colId: 'email',
        field: 'email',
        headerName: 'Email',
        cellDataType: 'text',
        sortable: false,
        valueFormatter: (params: ValueFormatterParams) => {
            if (Array.isArray(params.value)) {
                return params.value.join(', ');
            }
            return params.value || '';
        }
    },
    {
        colId: 'position',
        field: 'position',
        headerName: 'Position',
        cellDataType: 'text'
    },
    {
        colId: 'isMain',
        field: 'isMain',
        headerName: 'Main Contact',
        width: 150,
        sortable: false,
        filter: false,
        suppressHeaderMenuButton: true,
        cellRenderer: (params: ICellRendererParams) => {
            if (params.value) {
                return '<span class="badgeMain primaryColor">Main Contact</span>';
            }
            return '';
        }
    },
    {
        colId: 'actions',
        headerName: '',
        maxWidth: 80,
        sortable: false,
        filter: false,
        resizable: false,
        suppressHeaderMenuButton: true,
        suppressSizeToFit: true,
        cellRenderer: CustomCellActionsComponent,
        cellClass: 'action-cell'
    }
];
